(function () {
  function play(el) {
    if (!el || !el.classList) return;
    el.classList.remove('pr-play');
    void el.offsetWidth;
    el.classList.add('pr-play');
  }
  function enhance() {
    var tpl = document.getElementById('pr-menu-tpl');
    if (!tpl) return;
    var src = tpl.querySelector('.pr-menu');
    if (!src) return;

    document.querySelectorAll('.menu-drawer').forEach(function (drawer) {
      // déjà injecté ? on ne refait pas
      if (drawer.querySelector('.pr-menu')) return;

      var nav = drawer.querySelector('.menu-drawer__navigation') || drawer.querySelector('.menu-drawer__menu');
      if (!nav) return;

      // masque le menu natif + les liens utilitaires natifs (pays/compte/social)
      var navEl = drawer.querySelector('.menu-drawer__navigation');
      if (navEl) navEl.style.display = 'none';
      var util = drawer.querySelector('.menu-drawer__utility-links');
      if (util) util.style.display = 'none';

      // injecte le menu Princess Room (identique maquette)
      var custom = src.cloneNode(true);
      custom.removeAttribute('id');
      custom.hidden = false;
      var closeBtn = drawer.querySelector('.menu-drawer__close-button');
      if (closeBtn && closeBtn.parentNode === drawer) {
        closeBtn.insertAdjacentElement('afterend', custom);
      } else {
        drawer.insertBefore(custom, drawer.firstChild);
      }
      play(custom);
    });
  }

  // Rejoue l'animation d'entrée en cascade
  function replay() {
    document.querySelectorAll('.menu-drawer .pr-menu').forEach(play);
  }

  // Ré-injecte tant que le thème (re)construit le tiroir — auto-réparateur
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; enhance(); }, 80);
  }

  if (document.readyState !== 'loading') enhance();
  else document.addEventListener('DOMContentLoaded', enhance);
  window.addEventListener('load', enhance);
  document.addEventListener('shopify:section:load', enhance);

  // Observe l'apparition/reconstruction du tiroir
  try {
    var obs = new MutationObserver(schedule);
    obs.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  // Filet de sécurité : ré-injecte + rejoue l'animation à l'ouverture du menu
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('summary, [aria-controls], .header__icon--menu, header-drawer, .menu-toggle');
    if (t) setTimeout(function () { enhance(); replay(); }, 60);
  });
})();
